module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_01.9688c2ef.png";